import {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {useLocation} from 'react-router-dom';
import {InstantAppModalPage} from '../Agent/Quotes/InstantAppModal';

export type RouteChangeConfirmDialogProps = {
    message: string;
    callback?: (ok: boolean) => void;
};

interface IWarningMessage {
    confirmText: string;
    messageText: string;
    cancelText: string;
}

export default function RouteChangeConfirmDialog({
    message: messageProp,
    callback: callbackProp,
}: RouteChangeConfirmDialogProps) {
    const [open, setOpen] = useState(false);
    const [simpleMessage, setSimpleMessage] = useState<string | undefined>();
    const [messageObject, setMessageObject] = useState<IWarningMessage | undefined>();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const modalPage = searchParams.get('modalPage')?.toUpperCase() as InstantAppModalPage | null;

    useEffect(() => {
        if (callbackProp)
            if (modalPage) callbackProp(true);
            else setOpen(true);
    }, [callbackProp]);

    useEffect(() => {
        try {
            const parsedMessage = JSON.parse(messageProp);
            setMessageObject(parsedMessage);
            setSimpleMessage(undefined);
        } catch {
            setMessageObject(undefined);
            setSimpleMessage(messageProp);
        }
    }, [messageProp]);

    const handleClose = (stay: boolean) => {
        if (callbackProp) {
            callbackProp(stay);
        }
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            disableBackdropClick
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Unsaved Form</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {/* {alert(simpleMessage)}
                    {alert(messageObject?.messageText)} */}
                    {simpleMessage ? simpleMessage : messageObject?.messageText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleClose(true)} color="primary">
                    {simpleMessage ? 'Leave' : messageObject?.cancelText}
                </Button>
                <Button onClick={() => handleClose(false)} color="primary" autoFocus>
                    {simpleMessage ? 'Stay' : messageObject?.confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
